<template>
	{{ datetimeDisplay }}
</template>

<script>
import { computed, toRef } from 'vue';

import { datetimeToString } from '@/components/common/dateUtils';

export default {
	components: {
	},
	props: {
		value: {
			type: Object,
			required: true,
		},
		defaultValue: {
			type: String,
			required: false,
			default: null,
		},
	},
	setup(props) {
		const valueRef = toRef(props, 'value');
		const defaultValueRef = toRef(props, 'defaultValue');
		const datetimeDisplay = computed(() => datetimeToString(valueRef.value, defaultValueRef.value));
		return {
			datetimeDisplay,
		};
	},
}
</script>